import { styled } from '@mui/material/styles';

const StyledExternalCapabilities = styled('ul')`
  list-style: none;
  padding: 0;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

export default StyledExternalCapabilities;
